import { render, staticRenderFns } from "./Tarja.vue?vue&type=template&id=5248fcc0&"
import script from "./Tarja.vue?vue&type=script&lang=js&"
export * from "./Tarja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports